import { render, staticRenderFns } from "./InputsCustomQuestion.vue?vue&type=template&id=5a04e579&scoped=true&"
import script from "./InputsCustomQuestion.vue?vue&type=script&lang=js&"
export * from "./InputsCustomQuestion.vue?vue&type=script&lang=js&"
import style0 from "./InputsCustomQuestion.vue?vue&type=style&index=0&id=5a04e579&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04e579",
  null
  
)

export default component.exports